import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet-async';

const Helmet = ({ title, description, image, url, pageType }) => {
  const formattedTitle = pageType === 'home' ? `Moncong Publik | Beranda` : title;

  return (
    <ReactHelmet>
      <title>{formattedTitle}</title>
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />
    </ReactHelmet>
  );
};

Helmet.defaultProps = {
  title: 'Moncong Publik',
  description: 'Welcome to Moncong Publik, your source for the latest articles and videos.',
  image: '/path/to/default-image.jpg',
  url: 'https://moncongpublik.com',
};

export default Helmet;